import { FC } from "react";
import DeleteModal from "../common/DeleteModal";
import { queryKeys } from "../../services/react-query/queryKeys";
import { deletePackage } from "../../network/package";
import { useIntl } from "react-intl";

interface DeletePackageProps {
  visible: boolean;
  onClose: () => void;
  editPackageData: any | null; // Define the editPackageData prop
  locationId: number;
}

const DeletePackage: FC<DeletePackageProps> = ({
  visible,
  onClose,
  editPackageData,
  locationId,
}) => {
  const intl = useIntl();
  return (
    <DeleteModal
      visible={visible}
      onClose={onClose}
      onDelete={deletePackage} // Pass the delete function for "Package"
      data={{ locationId, packageId: editPackageData?.id }}
      optionalParam2={editPackageData?.id}
      confirmationHeader={intl.formatMessage({
        id: "delete_package_confirmation_header",
      })}
      confirmationText={intl.formatMessage({
        id: "delete_package_confirmation_text",
      })}
      queryKey={queryKeys.listPackages} // Pass the correct key here
      successMessage={intl.formatMessage({
        id: "package_deleted_successfully",
      })}
    />
  );
};

export default DeletePackage;
